export const MAX_CHAT_WIDTH = 750;

export const SIDE_PANEL_WIDTH = 420;

export const ASSISTANT_ERROR_CODES = {
    // Bad Request
    AE0001: 'AE0001',
    // Unauthorized
    AE0002: 'AE0002',
    // Forbidden
    AE0003: 'AE0003',
    // Not Found
    AE0004: 'AE0004',
    // Rate Limited
    AE0005: 'AE0005',
    // Unavailable
    AE0006: 'AE0006',
    // Stream Error
    AE0007: 'AE0007',
};

export const getAssistantErrorLocaleKey = errorCode =>
    ASSISTANT_ERROR_CODES[errorCode]
        ? `aiAssistant.errors.${ASSISTANT_ERROR_CODES[errorCode]}`
        : 'aiAssistant.errors.fallback';

// Error codes where re-submitting the last message is a sensible recovery action.
// Transient failures only — deterministic errors (auth, bad request, etc.) are excluded.
export const RETRYABLE_ERROR_CODES = [
    // Rate Limited
    ASSISTANT_ERROR_CODES.AE0005,
    // Unavailable
    ASSISTANT_ERROR_CODES.AE0006,
    // Stream Error
    ASSISTANT_ERROR_CODES.AE0007,
];

export const ASSISTANT_MODES = {
    AI: 'ai',
    HUMAN: 'human',
};

// chat-api's message author types. `customer` is the signed-in user; the rest render
// on the assistant side of the thread.
export const USER_TYPES = {
    AI: 'ai',
    CUSTOMER: 'customer',
    EMPLOYEE: 'employee',
    SYSTEM: 'system',
};

// Capabilities chat-api may report as denied on an AI reply (`metadata.access.denied`).
export const ACCESS_KEYS = ['users', 'assessments', 'dsar', 'cmp'];

/**
 * Whether an assistant-side message is the AI's own reply rather than an agent's or a
 * stored system row. The locally streamed placeholder carries no `userType`; it is an
 * AI reply by construction.
 *
 * @param {{userType?: string}} [message]
 * @returns {boolean}
 */
export const isAiAuthored = message => !message?.userType || message.userType === USER_TYPES.AI;

// localStorage key tracking that the user has acknowledged the AI consent screen.
// Consent is a user/product-level acknowledgement of the AI terms, so it is intentionally
// not namespaced per customer/tenant. If localStorage is cleared, the user re-acknowledges.
export const AI_CONSENT_STORAGE_KEY = 'aiConsentAcknowledged';

/*
 * HelpScout statuses we treat as "done" — the conversation is read-only. `closed`
 * is the normal completion state; `pending` and `spam` are also terminal.
 */
export const DONE_STATUSES = ['closed', 'pending', 'spam'];

/*
 * Rows per conversation-list request. chat-api pages the list by offset, so every
 * request — the hydrate, each "load more", and the silent refreshes after a send or an
 * escalation — has to ask for the same size or a later page skips or re-serves rows.
 * 100 is chat-api's ceiling.
 */
export const CONVERSATIONS_PAGE_SIZE = 100;
